import { NewsHighlight } from './highlights';

export const HighlightsTranslationsEn: Partial<NewsHighlight>[] = [
  {
    title: `New page: Ongoing maintenances`,
    description: `Keep track of all **currently active maintenances** from a single, dedicated page.

Instantly see which perimeters are under maintenance right now, so you can **interpret your data in context** and steer clear of false alerts.`,
  },
  {
    title: `HAR viewer redesigned`,
    imageAlt: `Waterfall window listing 277 network requests with their status, size and timeline.`,
    description: `The **HAR viewer** has been redesigned and is now **better integrated into the portal**.

It is also **faster**, making network waterfalls easier to explore.`,
  },
  {
    title: `🤖 Agentic AI: MCP server`,
    description: `The platform now ships an **MCP server**, opening the door to **agentic AI**.

Connect your favorite AI assistant and let it **query your data, explore your measures, and surface insights** directly from the platform — all through natural language.`,
  },
  {
    title: `Scoring: SLA calculation options`,
    description: `Scoring tables can now display a **all percentage column**.

Get a **SLA result tailored to your needs**: maintenance can be in or out of your SLA, considering maintenance as OK periods.`,
  },
  {
    title: `Delegated Scripts: action groups`,
    imageAlt: `The "Add action group" button of the script editor.`,
    description: `Script steps are now organized into **action groups**, bringing more structure and clarity to complex scripts.

On top of that, action groups can be **shared across multiple scripts** — create one once, reuse it everywhere. Any update is **instantly reflected in all scripts** that use it.

Manage your shared groups from the dedicated **Shared Action Groups** page in Settings.`,
  },
  {
    title: `Delegated Scripts: script versioning`,
    imageAlt: `Script versions panel: version V1, its save date and author, tagged "In production" and "Current".`,
    description: `Delegated Scripts now keeps a **full version history** of each script.

Every time you save, a new version is recorded. You can **browse past versions**, compare changes, and **restore any previous version** at any time — giving you a safety net when iterating on complex scripts.`,
  },
  {
    title: `💡 Improved forms inputs layout`,
    imageAlt: `Redesigned form: the fields of a "General information" section, each under its own label, required ones marked with an asterisk.`,
    description: `We’ve enhanced the **design and usability of form inputs** to provide a **better experience for users**.

Forms are now more **streamlined and user-friendly**, ensuring greater clarity and ease of interaction.`,
  },
  {
    title: `New widget: States Grid`,
    imageAlt: `States Grid widget: ten measure cards coloured by state, green for OK, red for critical, grey for unknown.`,
    description: `The **States Grid** widget provides a **live visual overview of current measure states** using a grid of colored cards.

It is designed to quickly assess the health of a perimeter at a glance, with an emphasis on clarity and real-time visibility.`,
  },
  {
    title: `TOTP authentication is now available!`,
    description: `Enhance your account security with **TOTP authentication**.

Enable it now in your settings to add an extra validation step to each login and further protect your access.`,
  },
  {
    title: `New widget: Consecutive States Duration Table`,
    imageAlt: `Consecutive states duration table: per measure, the warning periods with their start, end and duration.`,
    description: `The **Consecutive States Duration Table** widget highlights **measures that remain in the same state** beyond a configured threshold.

It helps teams quickly identify abnormal persistence of states, such as long-running warnings or critical conditions.`,
  },
  {
    title: `⏯️ Discover dashboards playlists!`,
    imageAlt: `Playlist controls of the dashboard toolbar: previous, pause, next, and the progress bar of the current dashboard.`,
    description: `With dashboard playlists, your **dashboards automatically scroll** in the order you define, with a configurable display time for each one.

Ideal for large screens, control rooms, or presentations, your dashboards flow effortlessly, providing a **continuous and dynamic stream of information**.

Track your key indicators in real time, quickly spot trends, and always **keep an eye on what matters most**.

Playlists transform your dashboards into a modern, fluid, fully automated visual experience that makes **monitoring more efficient and enjoyable**.`,
  },
  {
    title: `Dashboard Documentation Update`,
    description: `We’ve refreshed our **Dashboard documentation 📖** to help you get started faster and make the most of all available features.

You’ll now find:

- A **Getting Started guide** to create your first dashboard
- A detailed **Widgets catalog** with practical use cases
- Guidance on **Variables, Reporting, and Playlists**

Check it out directly in the documentation and level up your dashboard usage!`,
  },
];
